define('v3/Common/Services/Backend/impersonationBackend',[
	'jquery',
	'BackendBase'
], function ($, BackendBase) {
	function ImpersonationBackend () {
		BackendBase.call(this);
	}
	ImpersonationBackend.prototype = $.extend({}, BackendBase.prototype);

	$.extend(ImpersonationBackend.prototype, {
		changeSchool: function (selectedSchoolIndex, selectedClassId) {
			return this._post('/V3/' + selectedClassId + '/Impersonation/ChangeSchool', {
				SelectedSchoolIndex: selectedSchoolIndex,
				SelectedClassId: selectedClassId
			});
		}
	});
	return new ImpersonationBackend();
});
